import React, { useEffect, useState } from 'react';
import CustomTab from '../../CustomTab/CustomTab';
import HeaderInfo from '../HeaderInfo/HeaderInfo';
import styles from './ClientInfo.module.scss';
import IndividualClientForm from './Form/Individual/IndividualClientForm';
import Nextbutton from '../NextButton/NextButton';
import CorporateClientForm from './Form/Corporate/CorporateClientForm';
import { connect } from 'react-redux';
import {
	getAgreementDataById,
	nextActiveStep,
	saveAgreementInfo,
} from '../../../redux/agreement/actions';
import removeAgreementField from '../../../api/Agreement/removeAgreementField.api';
import { useLocation, useParams } from 'react-router';
import _ from 'lodash';
import { saveClientInfoData } from '../../../api/Agreement/handleClientInfo.api';
import Grid from '@mui/material/Grid';

const ClientInfo = ({
	saveAgreementInfo,
	clientInfo,
	getAgreementDataById,
	nextActiveStep,
	isComplete,
	restIsComplete,
	defaultTab,
}) => {
	const params = useParams();
	const [tab, setTab] = useState(defaultTab || 0);
	const [individualFormsData, setIndividualFormsData] = useState();
	const [corporationInfoData, setCorporationInfoData] = useState();
	const [error, setError] = useState({});
	const [corporationError, setCorporationError] = useState({});

	const handleSaveClientInfo = async (isNext) => {
		if (tab === 0) {
			if (clientInfo && clientInfo.hasOwnProperty('corporation')) {
				removeAgreementField(params.id, 'corporation');
			}
			if (!isNext) {
				// this if block is for when user clicks save & exit
				saveClientInfoData(
					params.id,
					'individual',
					individualFormsData,
					false
				);
			}
			// saveAgreementInfo(params.id, 'individual', individualFormsData);
		} else if (tab === 1) {
			if (clientInfo && clientInfo?.hasOwnProperty('individual')) {
				removeAgreementField(params.id, 'individual');
			}
			saveAgreementInfo(params.id, 'corporation', corporationInfoData);
		}
		if (isNext) nextActiveStep();
	};

	return (
		<Grid container>
			<Grid item sm={12} md={12}>
				<HeaderInfo
					title={'Client Info'}
					subtitle={'Who is this agreement for?'}
					onSaveAndExit={() => handleSaveClientInfo(false)}
				/>
			</Grid>
			<Grid item sm={12} md={3}></Grid>
			<Grid item sm={12} md={9}>
				<div className={styles.clientInfoWrapper}>
					<div className={styles.tabWrapper}>
						<CustomTab
							items={['Individual', 'Corporation']}
							width={166}
							tab={tab}
							setTab={setTab}
						/>
					</div>

					{tab === 0 ? (
						<>
							<div className={styles.formWrapper}>
								<IndividualClientForm
									individualFormsData={individualFormsData}
									setIndividualFormsData={
										setIndividualFormsData
									}
									tab={tab}
									error={error}
									setError={setError}
									handleSaveClientInfo={handleSaveClientInfo}
								/>
							</div>
						</>
					) : (
						<div className={styles.formWrapper}>
							<CorporateClientForm
								corporationInfoData={corporationInfoData}
								setCorporationInfoData={setCorporationInfoData}
								corporationError={corporationError}
								tab={tab}
								setCorporationError={setCorporationError}
								handleSaveClientInfo={handleSaveClientInfo}
								clientInfo={clientInfo}
							/>
						</div>
					)}

					<div className={styles.nextButtonWrapper}>
						<Nextbutton form='client-details-form' type='submit' />
					</div>
				</div>
			</Grid>
		</Grid>
	);
};

const mapStateToProps = (state) => ({
	clientInfo: state.agreement.agreementById?.clientInfo,
});

export default connect(mapStateToProps, {
	saveAgreementInfo,
	getAgreementDataById,
	nextActiveStep,
})(ClientInfo);
